import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';

/** App frame: persistent sidebar + sticky top bar + scrollable content.
 *  On small screens the sidebar becomes an overlay drawer. */
export function AppShell({ children }: { children: ReactNode }) {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => setMobileOpen(false), [pathname]);

  return (
    <div className="flex h-full overflow-hidden bg-canvas">
      {/* Desktop sidebar */}
      <div className="hidden lg:block">
        <Sidebar collapsed={collapsed} onToggle={() => setCollapsed((c) => !c)} />
      </div>

      {/* Mobile drawer */}
      {mobileOpen && (
        <div className="fixed inset-0 z-40 lg:hidden">
          <div className="absolute inset-0 bg-black/60" onClick={() => setMobileOpen(false)} />
          <div className="absolute inset-y-0 left-0 animate-fade-in">
            <Sidebar collapsed={false} onToggle={() => setMobileOpen(false)} />
          </div>
        </div>
      )}

      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar onMenu={() => setMobileOpen(true)} />
        <main className={cn('flex-1 overflow-y-auto')}>
          {/* Sin la caja de 1320px: esto es una herramienta de tablas y en un monitor de
              1920 esa caja dejaba ~350px muertos justo donde faltaban columnas. El tope
              alto es sólo para pantallas ultrapanorámicas. La medida de LECTURA se acota
              donde hay párrafos (`max-w-prosa`) — el max-width va a la columna de texto,
              nunca a la sección. */}
          <div className="mx-auto max-w-[1920px] space-y-6 px-5 py-6 animate-fade-in xl:px-8">{children}</div>
        </main>
      </div>
    </div>
  );
}
